export const NewZealand = {
    name: "New Zealand",
    image: "/New_Zeeland.jpg",
    overview: {
        title: "Why Bangladeshi Students Choose New Zealand for Higher Studies?",
        descriptions: [
            "Bangladeshi students choose New Zealand for its high-quality education system, safe environment, and excellent post-study work opportunities. The country offers a unique blend of academic excellence and natural beauty.",
            "New Zealand's innovative teaching methods, strong research culture, and welcoming attitude towards international students make it an attractive destination for quality education and career development."
        ],
    },
    highlights: [
        {
            icon: "fas fa-city",
            title: "Student-friendly cities",
            description: "Auckland and Wellington rank among the top student cities globally, known for their excellent universities and quality of life."
        },
        {
            icon: "fas fa-briefcase",
            title: "Post-study work rights",
            description: "New Zealand offers up to 3 years of post-study work opportunities through the Post-Study Work Visa."
        },
        {
            icon: "fas fa-graduation-cap",
            title: "Top universities",
            description: "New Zealand has 8 universities, with University of Auckland ranking in the top 100 of the QS World University Rankings."
        },
        {
            icon: "fas fa-users",
            title: "Safe environment",
            description: "New Zealand is consistently ranked as one of the safest countries in the world, providing a secure environment for international students."
        }
    ],
    keyFacts: [
        { factNumber: "8", factLabel: "Universities" },
        { factNumber: "50,000", factLabel: "International Students in New Zealand in 2024" },
        { factNumber: "20 Hours", factLabel: "Per week Part-time work permit" },
        { factNumber: "3 Years", factLabel: "Post-study work permit" }
    ],
    stats: {
        capital: "Wellington",
        poplulation: "5.2 million",
        economicGrowthRate: "2.7%",
        currency: "New Zealand Dollar (NZD)",
        language: "English",
        weather: [
            "Auckland: 8°C - 15°C",
            "Wellington: 6°C - 12°C",
            "Christchurch: 2°C - 12°C",
            "Dunedin: 3°C - 13°C"
        ]
    },
    requirements: [
        "Academic transcripts",
        "English proficiency test scores (IELTS, TOEFL, PTE)",
        "Statement of Purpose",
        "Letter of Recommendation",
        "Valid passport copy",
        "Proof of finances (Bank statements)",
        "Health insurance",
        "Medical certificate"
    ],
    intake: {
        title: "New Zealand universities offer two main intakes:",
        intakes: [
            {
                name: "Semester 1",
                month: "Starts in February/March"
            },
            {
                name: "Semester 2",
                month: "Starts in July/August"
            }
        ]
    },
    programs: [
        {
            name: "Certificate",
            duration: "6 months - 1 year"
        },
        {
            name: "Diploma",
            duration: "1-2 years"
        },
        {
            name: "Bachelor's Degree",
            duration: "3-4 years"
        },
        {
            name: "Master's Degree",
            duration: "1-2 years"
        },
        {
            name: "PhD",
            duration: "3-4 years"
        }
    ],
    popularPrograms: {
        title: "New Zealand offers high-quality education with focus on innovation and practical learning. Popular programs for international students include:",
        programs: [
            "Agriculture",
            "Engineering",
            "Business Administration",
            "Computer Science",
            "Environmental Science",
            "Medicine",
            "Tourism",
            "Education",
            "Creative Arts"
        ]
    },
    costs: [
        {
            program: "Foundation/Pathway",
            local: "NZD 15,000 - 25,000",
            bdt: "9,00,000 – 15,00,000 BDT"
        },
        {
            program: "Undergraduate Courses",
            local: "NZD 22,000 - 35,000",
            bdt: "13,20,000 – 21,00,000 BDT"
        },
        {
            program: "Postgraduate Courses",
            local: "NZD 26,000 - 40,000",
            bdt: "15,60,000 – 24,00,000 BDT"
        },
        {
            program: "PhD Programs",
            local: "NZD 6,000 - 9,000",
            bdt: "3,60,000 – 5,40,000 BDT"
        }
    ],
    topCities: {
        title: "New Zealand offers excellent education in several beautiful cities with high quality of life. Key student cities include:",
        cities: [
            {
                name: "Auckland",
                description: "Largest city with top universities and diverse opportunities"
            },
            {
                name: "Wellington",
                description: "Capital city with excellent university and government opportunities"
            },
            {
                name: "Christchurch",
                description: "Garden city with strong engineering and health programs"
            },
            {
                name: "Dunedin",
                description: "University city with focus on research and innovation"
            },
            {
                name: "Hamilton",
                description: "Growing city with excellent university and research facilities"
            },
            {
                name: "Palmerston North",
                description: "University town with focus on agriculture and sciences"
            }
        ]
    },
    workOptions: {
        partTimeWork: "International students can work up to 20 hours per week during study periods and full-time during breaks. Students typically earn NZD 18-25 per hour. The work experience in New Zealand's innovative companies can be highly valuable.",
        postStudyWork: "The Post-Study Work Visa allows graduates to stay and work in New Zealand for up to 3 years after graduation. This provides an excellent opportunity to gain work experience in New Zealand's strong economy and potentially qualify for permanent residency."
    },
    faqs: [
        {
            question: "How do I apply for a student visa in New Zealand?",
            answer: "To apply for a student visa, you need an offer letter from a New Zealand institution, proof of English proficiency, financial capacity (NZD 15,000 per year), health insurance, and a completed visa application form. The application is processed through Immigration New Zealand."
        },
        {
            question: "What are the English language requirements for studying in New Zealand?",
            answer: "Most New Zealand institutions require IELTS (6.0-6.5), TOEFL (80-90), or PTE (50-65) scores. Some programs may require higher scores, especially for competitive programs."
        },
        {
            question: "Can I work while studying in New Zealand?",
            answer: "Yes, international students can work up to 20 hours per week during study periods and full-time during breaks. The Post-Study Work Visa allows graduates to work after completing their studies."
        },
        {
            question: "Are scholarships available for international students in New Zealand?",
            answer: "Yes, there are various scholarships offered by the New Zealand government, universities, and external organizations. These include the New Zealand Excellence Awards, university-specific scholarships, and research grants."
        },
        {
            question: "How much does it cost to study in New Zealand from Bangladesh?",
            answer: "Studying in New Zealand from Bangladesh costs around NZD 22,000-40,000 for tuition, NZD 1,200-1,800 per month for living expenses, and NZD 500-800 for health insurance annually. Total annual cost ranges from NZD 37,000-62,000."
        },
        {
            question: "What GPA is required to study in New Zealand from Bangladesh?",
            answer: "To study in New Zealand from Bangladesh, the required GPA typically ranges from <strong>3.0 to 3.5</strong> on a 4.0 scale for undergraduate programs and <strong>3.2 to 3.7</strong> for postgraduate programs, depending on the university and program competitiveness."
        }
    ]
}
